import FindLocationResultState from '../data/schema/FindLocationResultState';
import { action } from 'satcheljs/lib/legacy';

/**
 * Resets the find location state. Used by the FindLocation component to clean up it's state when a location is added
 */
export default action('resetFindLocationState')(function resetFindLocationState(
    findLocationResultState: FindLocationResultState
) {
    if (findLocationResultState) {
        findLocationResultState.queryString = '';
        findLocationResultState.shouldShowFindResult = false;
        findLocationResultState.findResultSet = [];
        findLocationResultState.findResultHightlightIndex = 0;
        findLocationResultState.isSearching = false;
    }
});
